<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header" v-if="$store.getters.getUser">
      <span class="d-md-down-none">{{ $store.getters.getUser.name }}</span> 
      <span class="d-sm-block d-md-block d-lg-none d-xl-none mr-2"> <i class="fa fa-user"></i> </span>
      <i class="icon-arrow-down ml-2"></i>

      <span v-if="$store.getters.getCurrentProject !== null"></span>
    </template>
    <template slot="dropdown">
      <b-dropdown-header tag="div" class="text-center d-sm-block d-md-block d-lg-none d-xl-none"><strong v-if="$store.getters.getUser"> {{ $store.getters.getUser.name }} </strong></b-dropdown-header>
      <b-dropdown-header tag="div" class="text-center"><strong>Platform</strong></b-dropdown-header>
      <b-dropdown-item exact :to="`/?force=true`"> <b-icon icon="toggle-on" scale="0.8" style="margin-right:10px;margin-left:-7px"/> {{ $t('changeProject') }} </b-dropdown-item>
      <b-dropdown-item exact :to="`/admin/projects/settings#usage`" v-if="$isAdmin()"><i class="fa fa-database" /> {{ $t('usage') }} </b-dropdown-item>
      <b-dropdown-item exact :to="`/platform/updates`"><i class="fa fa-magic" /> {{ $t('updates') }} </b-dropdown-item>
      <b-dropdown-item @click="goToDocs"><i class="fa fa-question" /> {{ $t('tutorials.title') }}
      </b-dropdown-item>
      <b-dropdown-item exact :to="`/admin/scout/events`" class="d-sm-block d-md-block d-lg-none d-xl-none"><i class="icon-bell" /> {{ $t('notifications') }} </b-dropdown-item>
      <b-dropdown-header
        v-if="$isAdmin()"
        tag="div"
        class="text-center">
        <strong>{{ $t('currency') }}</strong>
      </b-dropdown-header>
      <b-dropdown-item exact to="/admin/users/credits/history" v-if="$isAdmin()"> <i class="icon-credit-card" /> {{ $t('credits') }}
        <b-badge variant="success" v-if="$store.getters.getUser">{{ $store.getters.getUser.credits }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-header
        tag="div"
        class="text-center">
        <strong>{{ $t('settings') }}</strong>
      </b-dropdown-header>
      <b-dropdown-item exact :to="`/users/profile`"><i class="fa fa-user" />{{ $t('profile') }}</b-dropdown-item>
      <b-dropdown-item exact to="/admin/projects/settings"><i class="fa fa-wrench"/>{{ $t('settings') }}</b-dropdown-item>
      <b-dropdown-item exact :to="`/admin/components`" v-if="components.length > 0 && $can('manage base_components')"><i class="fa fa-tasks" />{{ $t('components') }}
        <b-badge variant="primary">{{ components.length }}</b-badge>
      </b-dropdown-item>

      <b-dropdown-divider />
      <b-dropdown-item v-on:click="logout()"><i class="fa fa-lock" />{{ $t('logout') }}</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'

export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return {
      itemsCount: 0,
      projectInfo: null,
      components: [],
      showTutorial: false
    }
  },
  computed: {
    projects() {
      return this.$store.getters.projects
    },

    widgets() {
      return this.$store.getters.widgets
    },

    docsUrl() {
      return this.$env.get('DOCS_URL')
    },

    workspace() {
      return this.$store.getters.getCurrentWorkspace
    }
  },
  methods: {
    logout() {
      this.$http.post("/v1/user/logout").then(resp => {
        this.$router.go()
      })
    },

    goToDocs() {
      this.$store.commit("START_TUTORIAL", "introduction")
      this.$store.commit("SET_VIEW_MORE_TUTORIALS", true)
    }
  },
  mounted: function() {
    this.$store.dispatch('setUser')

    this.$store.dispatch("fetchProjectInfo").then(data => {
      this.projectInfo = data
    }).catch(error => {
      if (error.response !== undefined) {
        if (error.response.status == 500) {
          this.$serverErrorModal(error)
          return
        }
      }
    })

    this.$store.dispatch("fetchComponents").then(data => {
      this.components = data
    }).catch(error => {
      if (error.response !== undefined) {
        if (error.response.status == 500) {
          this.$serverErrorModal(error)
          return
        }
      }

      this.$debugLog(error)
    })
  }
}
</script>
